import { getFilesBatch } from '../../../services/fileSystemService';

// Support-related keywords that should redirect to settings
export const SUPPORT_KEYWORDS = [
  'cancel',
  'subscription',
  'billing',
  'account',
  'membership',
  'payment',
  'refund',
  'unsubscribe',
  'delete account',
  'close account',
];

// Tools enabled for the multi-file AI chat
export const ENABLED_TOOLS = [
  'search_content',
  'list_recent_files',
  'get_file_summary',
  'get_file_transcript',
  'get_user_memory',
  'rename_file',
  'list_folders',
  'list_folder_contents',
  'get_folder_info',
  'get_video_screenshot',
  'trim_video',
  'combine_videos',
] as const;

/**
 * Batch fetch files by IDs using the /v2/files/batch endpoint.
 * Returns an array of file objects (nulls filtered out).
 */
export async function fetchFilesByIds(fileIds: string[]): Promise<any[]> {
  if (fileIds.length === 0) return [];
  try {
    const result = await getFilesBatch({ fileIds, shareIds: [] });
    if (!result?.files) return [];
    return fileIds
      .map((id) => {
        const file = result.files[id];
        return file ? { ...file } : null;
      })
      .filter(Boolean);
  } catch (error) {
    console.error('[MultiFileChat] Batch file fetch failed:', error);
    return [];
  }
}

/**
 * Get a human-readable description for a tool call.
 */
export function getToolDescription(
  toolName: string,
  args: Record<string, unknown>,
): string {
  switch (toolName) {
    case 'search_content':
      return `Searching: "${args.query || 'content'}"`;
    case 'list_recent_files':
      return `Listing recent recordings${args.limit ? ` (${args.limit})` : ''}`;
    case 'get_file_summary':
      return 'Getting file summary';
    case 'get_file_transcript':
      return 'Getting transcript';
    case 'get_user_memory':
      return 'Accessing your preferences';
    case 'rename_file':
      return 'Renaming file';
    case 'list_folders':
      return 'Listing folders';
    case 'list_folder_contents':
      return 'Listing folder contents';
    case 'get_folder_info':
      return 'Getting folder info';
    case 'get_video_screenshot':
      return `Capturing screenshot${args.timestamp ? ` at ${args.timestamp}s` : ''}`;
    default:
      return `Running ${toolName}`;
  }
}
